<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20"
      r="19.625"
      fill="#FBBA13"
      stroke="#E0E0E0"
      stroke-width="0.75"
    />
    <g clip-path="url(#clip0_3963_9260)">
      <path
        d="M19.2804 10.2132L19.2804 10.2132L19.2818 10.2107C19.3344 10.1183 19.4241 10.0714 19.5244 10.0714C19.6221 10.0714 19.7123 10.1164 19.7685 10.2135C19.7685 10.2136 19.7686 10.2137 19.7686 10.2138L29.9378 27.858C29.9378 27.8581 29.9379 27.8582 29.938 27.8583C30.0487 28.0521 29.9084 28.2857 29.6944 28.2857H9.35434C9.14034 28.2857 8.99999 28.0521 9.11071 27.8584C9.11078 27.8582 9.11085 27.8581 9.11092 27.858L19.2804 10.2132ZM10.784 26.6759L10.352 27.4255H11.2172H27.8315H28.6967L28.2647 26.6759L19.9576 12.2603L19.5244 11.5085L19.0911 12.2603L10.784 26.6759ZM19.0486 24.7549C18.9221 24.6282 18.8509 24.456 18.8509 24.2762C18.8509 24.0964 18.9221 23.9243 19.0486 23.7975C19.175 23.6708 19.3461 23.5998 19.5244 23.5998C19.7026 23.5998 19.8737 23.6708 20.0001 23.7975C20.1266 23.9243 20.1978 24.0964 20.1978 24.2762C20.1978 24.456 20.1266 24.6282 20.0001 24.7549C19.8737 24.8816 19.7026 24.9526 19.5244 24.9526C19.3461 24.9526 19.175 24.8816 19.0486 24.7549ZM19.8067 21.0313H19.242V17.1297H19.8067V21.0313Z"
        fill="#F9F9F9"
        stroke="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3963_9260">
        <rect
          width="21.9059"
          height="23.2143"
          fill="white"
          transform="translate(8.57141 8.57141)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
